module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEX///+nxBvIAAAAAXRSTlMavYQhHAAAAApJREFUCNdjYAAAAAIAAeIhvDMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/template/ie8_opacity_light_10.png
// module id = ../../../../../src/assets/img/template/ie8_opacity_light_10.png
// module chunks = 2